import { Route } from "./Route";
export class RouteWithParent extends Route {
    /**
     * @param _options
     * @param _parent
     */
    constructor(_options, _parent) {
        super(_options);
        this._options = _options;
        this._parent = _parent;
    }
    /**
     * @return {RouteWithParent}
     */
    get parent() {
        return this._parent;
    }
}
